import { IconButton } from '@/lib/Buttons';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

export const DownloadingAudienceButton: FC = () => {
  const { t } = useTranslation('audience_details');

  return <IconButton intent='secondary' isLoading={true} text={t('sources_and_rules.creatingTheFile')} />;
};
